import { LangProvider } from "../lib/i18n";
import Nav from "../components/Nav";
import Hero from "../components/Hero";
import Services from "../components/Services";
import Experience from "../components/Experience";
import Ebook from "../components/Ebook";
import Contact from "../components/Contact";
import LocationMap from "../components/LocationMap";
import Privacy from "../components/Privacy";
import Footer from "../components/Footer";
import WhatsAppFloating from "../components/WhatsAppFloating";
import EbookFloating from "../components/EbookFloating";

export default function Home() {
    return (
        <LangProvider>
            <div className="App min-h-screen bg-cream text-navy font-sans">
                <Nav />
                <main>
                    <Hero />
                    <Services />
                    <Experience />
                    <Ebook />
                    <Contact />
                    <LocationMap />
                    <Privacy />
                </main>
                <Footer />
                <WhatsAppFloating />
                <EbookFloating />
            </div>
        </LangProvider>
    );
}
